@if (exhibitor?.videos || exhibitor?.gallery) {
<section class="exhibitormedia">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <mat-tab-group class="tabs-spread exhibitormedia__tabs" (selectedTabChange)="trackTabChange($event)">
          @if (exhibitor?.gallery) {
          <mat-tab
            class="exhibitormedia__images"
            label="Bilder"
            i18n-label="@@featureExhibitorDetails-pageTabExhibitor-tabImages"
            aria-label="Bilder">
            <planone-swiper
              [desktopVariant]="'list'"
              (zoomChange)="imageZoomed($event)"
              (interaction)="trackSwiperInteraction($event)">
              @for (image of exhibitor?.gallery; track identifyImage($index, image)) {
              <ng-template #slide>
                <img
                  [src]="image.resource | ImageUrl : image.provider"
                  width="100%"
                  height="auto"
                  [alt]="image?.description" />
              </ng-template>
              <ng-template #title>
                @if (image?.description) {
                {{ image?.description }}
                } @if (!image?.description) {
                <i>Keine Beschreibung</i>
                }
              </ng-template>
              }
            </planone-swiper>
          </mat-tab>
          } @if (exhibitor?.videos) {
          <mat-tab
            class="exhibitormedia__videos"
            label="Videos"
            i18n-label="@@featureExhibitorDetails-pageTabExhibitor-tabVideos"
            aria-label="Videos">
            @if (cookieConsent$ | async) {
            <planone-video-swiper [desktopVariant]="'list'" [slides]="exhibitor?.videos"></planone-video-swiper>
            } @else {
            <planone-youtube-video-cookie-consent-overlay></planone-youtube-video-cookie-consent-overlay>
            }
          </mat-tab>
          }
        </mat-tab-group>
      </div>
    </div>
  </div>
</section>
}
